import {Field} from "formik";
import React, {Fragment, useEffect, useRef, useState} from "react";

export default function AutocompleteText({
                                             type = null,
                                             name,
                                             formikRef,
                                             formikValues,
                                             filterFunction,
                                             validate,
                                             classiAddizionali = '',
                                             filteredValues = [],
                                             toUpper = false,
                                             handlerChange = (ev) => {
                                             },
                                             handlerBlur = (ev) => {
                                             },
                                             handlerSelect = (val) => {
                                             },
                                         }) {

    const [show, setShow] = useState(false);

    // Uso useRef per far sì che il timer persista tra i render
    const timeoutRef = useRef(null);

    // Pulizia del timer allo smontaggio
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleSelection = (val) => {
        // 1. Se l'utente seleziona un elemento, cancello il timer dell'onBlur
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        const finalVal = toUpper ? val.toUpperCase() : val;

        // 2. Aggiorno Formik
        formikRef.current.setFieldValue(name, finalVal);

        // 3. Chiudo la lista e chiamo l'handler
        setShow(false);
        handlerSelect(finalVal);
    };

    return (
        <Fragment>
            <Field
                as={type}
                name={name}
                className={`form-control ${classiAddizionali}`}
                autoComplete="off"
                onKeyUp={(ev) => {
                    let newVal = ev.target.value ? ev.target.value.toUpperCase() : '';
                    filterFunction(newVal);
                    setShow(true);
                }}
                onChange={(ev) => {
                    let newVal = ev.target.value ? ev.target.value.toUpperCase() : '';
                    formikRef.current.setFieldValue(name, newVal);
                    handlerChange(ev);
                }}
                onBlur={(ev) => {
                    // Persisto l'evento perché setTimeout lo renderebbe nullo (in versioni vecchie di React)
                    const eventPersist = {...ev, target: {...ev.target}};

                    // Ritardo l'onBlur per vedere se l'utente clicca sulla lista
                    timeoutRef.current = setTimeout(() => {
                        setShow(false);
                        handlerBlur(eventPersist);
                    }, 200); // 200ms sono sufficienti per far scattare l'onClick prima
                }}
                value={formikValues[name] || ''}
                validate={validate}
            />
            <div className={"ns-autocomplete"}>
                {
                    filteredValues && filteredValues.length > 0 && show &&
                    <div className={"ns-autocomplete-container"}>
                        <ul className={'ns-list-no-bullet'}>
                            {
                                filteredValues.map((val, idx) => (
                                    <li
                                        className={"ns-cursor-pointer"}
                                        key={idx}
                                        // Uso onMouseDown perché scatta prima dell'onBlur
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => handleSelection(val)}
                                    >
                                        {toUpper ? val.toUpperCase() : val}
                                    </li>
                                ))}
                        </ul>
                    </div>
                }
            </div>
        </Fragment>
    );
}